import { ICarrierPortalGlobalStore } from '../models/carrier-portal-global.interface';
import { initialCarrierPortalSettingsState } from './carrierPortalSettingStore';
import { initialComplianceState } from './complianceStore';
import { initialContractState } from './contractStore';
import { initialDateFilterState } from './date-filter-store';
import { initialInvoiceState } from './invoiceStore';
import { initialMenuState } from './menu-store';
import {
  createStore,
  initialCarrierDetailsState,
  initialCurrencyDetailsState,
  initialDamagesClaimsValues,
  initialEquipmentValues,
  initialReferencesValues,
  initialServiceLevelValues,
  initialShipmentTypesValues,
  initialStoreState,
  initialTransportationModesValues,
  initialUnitOfMeasureValues
} from './store';
import { initialTransportCombinedState } from './transport-global-store';
import { initialUpdateDetailsState } from './updateDetailsStore';
import { initialUploadDocumentsState } from './uploadDocumentsStore';
import { initialUploadPODState } from './uploadPODStore';

export const initialCarrierPortalGlobalStoreState: ICarrierPortalGlobalStore = {
  carrierportalSetting: initialCarrierPortalSettingsState,
  compliance: initialComplianceState,
  contract: initialContractState,
  dateFilter: initialDateFilterState,
  invoice: initialInvoiceState,
  menu: initialMenuState,
  transport: initialTransportCombinedState,
  updateDetails: initialUpdateDetailsState,
  uploadDocuments: initialUploadDocumentsState,
  uploadPOD: initialUploadPODState,
  store: initialStoreState,
  carrierDetails: initialCarrierDetailsState,
  currencyDetails: [initialCurrencyDetailsState],
  damagesClaims: initialDamagesClaimsValues,
  unitsOfMeasure: [initialUnitOfMeasureValues],
  transportationModes: [initialTransportationModesValues],
  shipmentTypes: [initialShipmentTypesValues],
  serviceLevels: [initialServiceLevelValues],
  equipmentTypes: [initialEquipmentValues],
  references: [initialReferencesValues]
};

export const {
  Provider: CarrierPortalGlobalStoreProvider,
  useStore: useCarrierPortalGlobalStore,
  useSetStore: useSetCarrierPortalGlobalStore,
  useSetStorePath: useSetCarrierPortalGlobalStorePath
} = createStore<ICarrierPortalGlobalStore>(
  initialCarrierPortalGlobalStoreState
);
